import { createQuiz } from "@/components/quizEngine";

const traits = ["hope", "kind", "clever", "bold", "proud", "cheerful", "mysterious", "loyal", "chaos"];

const bank = [
  ["Trapped in a school with a talking bear. Your first move?", [
    ["Find the others and stay hopeful", { hope: 2, kind: 1 }],
    ["Investigate every single room", { clever: 2, mysterious: 1 }],
    ["Demand to speak to whoever's in charge", { proud: 2, bold: 1 }],
    ["Try to break the door down", { bold: 2 }],
    ["Honestly? Kind of thrilled", { chaos: 2 }],
  ]],
  ["Your role in a class trial:", [
    ["The one who spots the contradiction", { clever: 2, bold: 1 }],
    ["The one who believes in everyone", { hope: 2, kind: 1 }],
    ["The one shouting objections", { bold: 2, cheerful: 1 }],
    ["The one quietly watching", { mysterious: 2 }],
    ["The one stirring things up for fun", { chaos: 2, clever: 1 }],
  ]],
  ["Pick the Ultimate talent you'd want:", [
    ["Ultimate Detective", { clever: 2 }],
    ["Ultimate Lucky Student", { hope: 2 }],
    ["Ultimate Supreme Leader", { chaos: 1, proud: 1, mysterious: 1 }],
    ["Ultimate Pop Sensation", { cheerful: 2 }],
    ["Ultimate Martial Artist", { bold: 1, loyal: 1 }],
  ]],
  ["Your friend is acting suspicious. You…", [
    ["Trust them anyway", { hope: 1, kind: 1, loyal: 1 }],
    ["Follow them secretly", { mysterious: 1, clever: 1 }],
    ["Confront them head-on", { bold: 2 }],
    ["Start a rumor to see what happens", { chaos: 2 }],
    ["Invite them for tea and just ask", { kind: 2 }],
  ]],
  ["Free time! Where do you go?", [
    ["The library", { clever: 2 }],
    ["The pool", { cheerful: 1, bold: 1 }],
    ["The music room", { cheerful: 2 }],
    ["The garden, to visit the animals", { kind: 2 }],
    ["Nowhere. I make my own fun", { chaos: 1, mysterious: 1 }],
  ]],
  ["Pick a snack:", [
    ["Donuts, lots of them", { cheerful: 2 }],
    ["Royal milk tea, made properly", { proud: 2 }],
    ["Instant ramen at midnight", { mysterious: 1, chaos: 1 }],
    ["A homemade bento", { kind: 2 }],
    ["A protein shake", { bold: 1, loyal: 1 }],
  ]],
  ["Monokuma reveals a new motive. You…", [
    ["Refuse. Hope always wins", { hope: 3 }],
    ["Analyze it for clues", { clever: 2 }],
    ["Laugh in his face", { bold: 1, chaos: 1 }],
    ["Worry about your friends first", { kind: 1, loyal: 2 }],
    ["Secretly think it over", { mysterious: 1, chaos: 1 }],
  ]],
  ["Your fashion style:", [
    ["Hoodie and sneakers", { hope: 1, kind: 1 }],
    ["Gothic lolita", { mysterious: 2, proud: 1 }],
    ["A tailored designer suit", { proud: 2 }],
    ["Band tees and ripped tights", { cheerful: 1, chaos: 1 }],
    ["My uniform, perfectly pressed", { loyal: 2 }],
  ]],
  ["What scares you most?", [
    ["Losing hope", { hope: 2 }],
    ["Being lied to", { clever: 1, loyal: 1 }],
    ["Being ordinary", { proud: 2 }],
    ["Being bored", { chaos: 2 }],
    ["Being alone", { kind: 1, cheerful: 1 }],
  ]],
  ["How do you spend a quiet night?", [
    ["Laughing with friends", { cheerful: 2, loyal: 1 }],
    ["Piecing together a mystery", { clever: 2 }],
    ["Writing a letter to someone you love", { kind: 2 }],
    ["Planning a big twist", { chaos: 1, mysterious: 1 }],
    ["Training until midnight", { bold: 2 }],
  ]],
  ["Pick a motto:", [
    ["Hope always wins", { hope: 3 }],
    ["The truth is all that matters", { clever: 2, bold: 1 }],
    ["Lies make life interesting", { chaos: 2, mysterious: 1 }],
    ["Never give up on your friends", { loyal: 2, kind: 1 }],
    ["Only the best deserve to win", { proud: 3 }],
  ]],
  ["How do you deal with a rival?", [
    ["Become friends", { kind: 2, hope: 1 }],
    ["Outsmart them", { clever: 2 }],
    ["Challenge them to a race", { bold: 1, cheerful: 1 }],
    ["Ignore them. They're beneath me", { proud: 2 }],
    ["Mess with their head", { chaos: 2 }],
  ]],
  ["Your secret hobby:", [
    ["Video games all night", { clever: 1, kind: 1 }],
    ["Writing songs", { cheerful: 2 }],
    ["Caring for rare animals", { mysterious: 1, kind: 1 }],
    ["High-stakes card games", { mysterious: 2, chaos: 1 }],
    ["Stargazing", { hope: 2 }],
  ]],
  ["A new student arrives. You…", [
    ["Welcome them warmly", { kind: 2 }],
    ["Size them up", { proud: 1, clever: 1 }],
    ["Recruit them into your plans", { chaos: 1, bold: 1 }],
    ["Invite them to a jam session", { cheerful: 2 }],
    ["Watch from a distance", { mysterious: 2 }],
  ]],
  ["Pick a color:", [
    ["Hopeful green", { hope: 2 }],
    ["Pink and black", { chaos: 2 }],
    ["Royal gold", { proud: 2 }],
    ["Detective purple", { clever: 1, mysterious: 1 }],
    ["Sunny yellow", { cheerful: 2 }],
    ["Galaxy violet", { bold: 1, hope: 1 }],
  ]],
  ["Choose a superpower:", [
    ["Unbeatable luck", { hope: 2 }],
    ["Reading minds", { clever: 2 }],
    ["Super strength", { bold: 2 }],
    ["Invisibility", { mysterious: 2 }],
    ["Making anyone laugh", { cheerful: 2 }],
  ]],
  ["Your dream ending to the killing game:", [
    ["Graduating with everyone", { hope: 2, loyal: 1 }],
    ["Uncovering the truth behind it all", { clever: 2 }],
    ["Ruling the school", { proud: 2 }],
    ["Escaping with your best friend", { loyal: 1, kind: 1 }],
    ["Flipping the whole game upside down", { chaos: 2 }],
  ]],
  ["Someone starts crying in front of you. You…", [
    ["Hug them", { kind: 2 }],
    ["Cheer them up with jokes", { cheerful: 2 }],
    ["Help fix the problem", { clever: 1, loyal: 1 }],
    ["Awkwardly hand them a tissue", { proud: 1, mysterious: 1 }],
    ["Tell them hope is stronger than despair", { hope: 2 }],
  ]],
  ["Your energy at a party:", [
    ["Life of the party", { cheerful: 2, bold: 1 }],
    ["Observing from the corner", { mysterious: 2 }],
    ["Judging everyone's outfits", { proud: 2 }],
    ["The chaotic DJ", { cheerful: 1, chaos: 1 }],
    ["Making sure everyone gets home safe", { loyal: 2 }],
  ]],
  ["Choose a pet:", [
    ["A tiny hamster army", { mysterious: 1, kind: 1 }],
    ["A loyal dog", { loyal: 2 }],
    ["A black cat", { mysterious: 2 }],
    ["A teddy bear that might talk", { chaos: 2 }],
    ["A dolphin to swim with", { cheerful: 1, bold: 1 }],
  ]],
  ["When you lose, you…", [
    ["Smile and try again", { hope: 2 }],
    ["Replay every move in your head", { clever: 2 }],
    ["Refuse to admit it", { proud: 2 }],
    ["Laugh it off", { cheerful: 2 }],
    ["Flip the table", { bold: 1, chaos: 1 }],
  ]],
];

const characters = [
  { name: "Makoto Naegi", title: "Ultimate Lucky Student", text: "Ordinary on the outside, unstoppable on the inside. Your hope lifts everyone around you.", traits: { hope: 3, kind: 2, loyal: 1 }, colors: ["#2d6a4f", "#f2f0ea", "#1b1b1f"] },
  { name: "Kyoko Kirigiri", title: "Ultimate Detective", text: "Cool, sharp and unreadable. You see the truth long before anyone else does.", traits: { clever: 3, mysterious: 2, loyal: 1 }, colors: ["#7b2cbf", "#c8a2ff", "#1b1b1f"], image: "/img/dr/kyoko.jpg" },
  { name: "Byakuya Togami", title: "Ultimate Affluent Progeny", text: "Brilliant, confident and a little bit arrogant. Second place was never an option.", traits: { proud: 3, clever: 2 }, colors: ["#f2f0ea", "#1b1b1f", "#e9b949"], image: "/img/dr/byakuya.jpg" },
  { name: "Aoi Asahina", title: "Ultimate Swimming Pro", text: "Sunny, sporty and big-hearted. You'd dive into anything for your friends.", traits: { cheerful: 2, bold: 2, kind: 1, loyal: 1 }, colors: ["#3a86ff", "#a0d2ff", "#ffd166"], image: "/img/dr/aoi.jpg" },
  { name: "Sayaka Maizono", title: "Ultimate Pop Sensation", text: "Bright as a stage light, with more going on behind your smile than people realize.", traits: { cheerful: 3, kind: 1, mysterious: 1 }, colors: ["#2b2d6e", "#f7b2c8", "#f2f0ea"], image: "/img/dr/sayaka.jpg" },
  { name: "Celestia Ludenberg", title: "Ultimate Gambler", text: "Elegant, mysterious and never bluffing. Or are you?", traits: { mysterious: 3, proud: 2, chaos: 1 }, colors: ["#1b1b1f", "#c1121f", "#f2f0ea"] },
  { name: "Chihiro Fujisaki", title: "Ultimate Programmer", text: "Gentle and shy, but brilliant and braver than you believe.", traits: { kind: 3, clever: 2 }, colors: ["#b8f2a8", "#f2f0ea", "#8fe3cf"] },
  { name: "Mondo Owada", title: "Ultimate Biker Gang Leader", text: "Loud, tough and fiercely loyal. A promise from you is unbreakable.", traits: { bold: 3, loyal: 2 }, colors: ["#1b1b1f", "#e9b949", "#6b5b5b"] },
  { name: "Junko Enoshima", title: "Ultimate Fashionista", text: "Trendy, bold and impossible to predict. Boredom is your only enemy.", traits: { chaos: 3, bold: 2, proud: 1 }, colors: ["#f7b2c8", "#1b1b1f", "#f2f0ea"], image: "/img/dr/junko.jpg" },
  { name: "Yasuhiro Hagakure", title: "Ultimate Clairvoyant", text: "Laid-back, lucky and totally sure your predictions are right about 30% of the time. Good vibes only.", traits: { cheerful: 2, chaos: 2, kind: 1 }, colors: ["#6b5b5b", "#ff6f61", "#2d6a4f"], image: "/img/dr/hagakure.jpg" },
  { name: "Sakura Ogami", title: "Ultimate Martial Artist", text: "Strong in body and heart. You protect the people you care about with honor.", traits: { loyal: 2, bold: 2, kind: 2 }, colors: ["#f2f0ea", "#6b5b5b", "#2b2d6e"] },
  { name: "Hajime Hinata", title: "Ultimate ???", text: "Searching for who you really are, and stronger for every step of the journey.", traits: { hope: 2, clever: 1, bold: 1, loyal: 1 }, colors: ["#6b5b5b", "#b8f2a8", "#f2f0ea"] },
  { name: "Nagito Komaeda", title: "Ultimate Lucky Student", text: "Hope-obsessed, unpredictable and strangely charming. Nobody can guess your next move.", traits: { hope: 3, chaos: 2, mysterious: 1 }, colors: ["#f2f0ea", "#2d6a4f", "#c1121f"] },
  { name: "Chiaki Nanami", title: "Ultimate Gamer", text: "Sleepy, sweet and secretly the smartest strategist in the room.", traits: { kind: 2, clever: 2, hope: 1 }, colors: ["#ffd6e0", "#f7b2c8", "#9fa8ff"] },
  { name: "Gundham Tanaka", title: "Ultimate Breeder", text: "Dramatic and dark on the surface, but a soft heart for every creature.", traits: { proud: 2, mysterious: 2, kind: 1 }, colors: ["#1b1b1f", "#6a2c70", "#e9b949"] },
  { name: "Sonia Nevermind", title: "Ultimate Princess", text: "Graceful, curious and kind. You lead with warmth and a love of the mysterious.", traits: { kind: 2, proud: 1, cheerful: 1, hope: 1 }, colors: ["#e9b949", "#fff8e7", "#a0d2ff"] },
  { name: "Ibuki Mioda", title: "Ultimate Musician", text: "A walking rock concert. Loud, joyful and gloriously chaotic.", traits: { cheerful: 3, chaos: 2 }, colors: ["#ff6f61", "#7b2cbf", "#1b1b1f"] },
  { name: "Kaede Akamatsu", title: "Ultimate Pianist", text: "Determined and warm, you bring people together and never stop pushing forward.", traits: { hope: 2, bold: 2, kind: 1 }, colors: ["#f7b2c8", "#ffd166", "#fff8e7"] },
  { name: "Shuichi Saihara", title: "Ultimate Detective", text: "Quiet and unsure at first, but your search for the truth makes you shine.", traits: { clever: 2, kind: 2, hope: 1 }, colors: ["#1b1b1f", "#2b2d6e", "#e9b949"] },
  { name: "Kokichi Oma", title: "Ultimate Supreme Leader", text: "A trickster with a grin. Is anything you say true? Just kidding. Or not!", traits: { chaos: 3, mysterious: 2, clever: 1 }, colors: ["#f2f0ea", "#6a2c70", "#1b1b1f"] },
  { name: "Kaito Momota", title: "Ultimate Astronaut", text: "Big dreams, bigger heart. You believe in your friends until they believe in themselves.", traits: { bold: 2, hope: 2, cheerful: 1, loyal: 1 }, colors: ["#6a2c70", "#9b5de5", "#ffd166"] },
];

export const DR = createQuiz({ traits, bank, characters });

export const DR_PAIRS = [
  ["Makoto Naegi", "Kyoko Kirigiri"], ["Hajime Hinata", "Chiaki Nanami"], ["Kaede Akamatsu", "Shuichi Saihara"],
  ["Aoi Asahina", "Sakura Ogami"], ["Mondo Owada", "Chihiro Fujisaki"], ["Gundham Tanaka", "Sonia Nevermind"],
];
